let next = 0;
if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = (callback, element) => {
        const now = Date.now();
        const dur = Math.max(0, next - now + 17);
        next = now + dur;
        return window.setTimeout(() => {
            callback(now + dur);
        }, dur);
    };
    window.cancelAnimationFrame = window.clearTimeout;
}
